import { useState } from 'react'

export default function Chart() {
  const [copied, setCopied] = useState(false)
  const contractAddress = '0x7A8aDCf432EbCC2311B955d176ee4BFED13bB9A7'

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contractAddress)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <section className="relative py-20 px-4 z-10 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 pt-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white text-center">
            $MANDOX Chart
          </h2>
        </div>

        <div className="mb-8 text-center">
          <p className="text-xl md:text-2xl font-bold text-white mb-2 animate-pulse">
            Big news coming soon for $MANDOX holders!
          </p>
          <p className="text-lg md:text-xl text-white/90">
            Be sure to stay connected — you won't want to miss this!
          </p>
        </div>

        <div className="w-full shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_50px_rgba(255,255,255,0.5)] transition-all duration-300 rounded-lg overflow-hidden" style={{ height: 'clamp(300px, 60vh, 600px)' }}>
          <iframe
            src="https://dexscreener.com/ethereum/0x7A8aDCf432EbCC2311B955d176ee4BFED13bB9A7?embed=1&theme=dark&trades=0&info=0"
            style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px' }}
            title="DexScreener Chart"
          />
        </div>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 px-4">
          <div className="text-white text-sm sm:text-lg text-center">
            <span className="text-gray-400 block sm:inline">Contract Address:</span>{' '}
            <span className="font-mono text-xs sm:text-base break-all">{contractAddress}</span>
          </div>
          <button
            onClick={copyToClipboard}
            className="px-6 py-3 bg-white text-black rounded-lg hover:bg-gray-200 transition-colors font-semibold text-sm sm:text-base"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>

        <div className="mt-12 max-w-5xl mx-auto">
          <div className="bg-black rounded-xl p-8 shadow-[0_0_30px_rgba(255,255,255,0.2)] hover:shadow-[0_0_50px_rgba(255,255,255,0.3)] transition-all duration-300">
            <h3 className="text-3xl font-bold text-white mb-8 text-center">Tokenomics</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
              <div className="bg-black rounded-lg p-6 shadow-[0_0_20px_rgba(255,255,255,0.1)] hover:shadow-[0_0_40px_rgba(255,255,255,0.2)] transition-all duration-300">
                <div className="text-gray-400 text-sm font-semibold mb-2 uppercase tracking-wider">Ticker</div>
                <div className="text-white text-2xl font-bold">$MANDOX</div>
              </div>

              <div className="bg-black rounded-lg p-6 shadow-[0_0_20px_rgba(255,255,255,0.1)] hover:shadow-[0_0_40px_rgba(255,255,255,0.2)] transition-all duration-300">
                <div className="text-gray-400 text-sm font-semibold mb-2 uppercase tracking-wider">Supply</div>
                <div className="text-white text-2xl font-bold">50T</div>
              </div>

              <div className="bg-black rounded-lg p-6 shadow-[0_0_20px_rgba(255,255,255,0.1)] hover:shadow-[0_0_40px_rgba(255,255,255,0.2)] transition-all duration-300">
                <div className="text-gray-400 text-sm font-semibold mb-2 uppercase tracking-wider">Tax</div>
                <div className="text-white text-2xl font-bold">0%</div>
              </div>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <a
              href="https://app.uniswap.org/swap?chain=mainnet&inputCurrency=NATIVE&outputCurrency=0x7a8adcf432ebcc2311b955d176ee4bfed13bb9a7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-white text-black rounded-lg font-bold text-lg hover:bg-gray-200 transition-colors shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:shadow-[0_0_40px_rgba(255,255,255,0.5)]"
            >
              Buy $Mandox Token
            </a>
            <div className="mt-4">
              <a
                href="https://etherscan.io/token/0x7A8aDCf432EbCC2311B955d176ee4BFED13bB9A7"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white transition-colors underline font-semibold"
              >
                View on Etherscan
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
